import { render, staticRenderFns } from "./UpdateAvatarForm.vue?vue&type=template&id=7967ecb0&scoped=true&"
import script from "./UpdateAvatarForm.vue?vue&type=script&lang=js&"
export * from "./UpdateAvatarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7967ecb0",
  null
  
)

export default component.exports